import React from 'react'
import TimeLine from './TimeLine';
import Dot3Logo from "../Assests/Images/dot3_logo.jpg";
import MegascaleLogo from "../Assests/Images/megascale_logo.jpg";
import DAIICTLogo from "../Assests/Images/daiict-logo.jpg";
import ShipmntsLogo from "../Assests/Images/ShipmntsLogo.jpg";

const data = [
    {
        date: "Jan 2026 - Till Date",
        title: "SDE - Intern",
        subtitle: "Tech Stack: Python , Javascript",
        logo: ShipmntsLogo,
    desc: [
    ]
    },
    {
        date: "May 2025 - August 2025",
        title: "Full Stack Developer Intern",
        subtitle: "Tech Stack: ReactJS,Tailwind CSS ,Node.js, MySQl",
        logo: DAIICTLogo,
    desc: [
        `• Developed two full-stack web applications, AISE (ACM) and ISMMACS (ISMMACS India), within 2 months using the MERN stack.`,
        `• Integrated ICICI payment gateway for seamless and secure fee transactions across both platforms.`,
        `• Implemented core features including event registration, hostel booking, travel grant approvals, and a complete admin panel for user and payment management.`,
        `• Enabled admins to export registered user data as Excel files and efficiently manage hostel room allocations.`
    ]
    },
    {
        date: "April 2024 - June 2024",
        title: "Backend Intern",
        subtitle: "Tech Stack: Node.js, MongoDB",
        logo: MegascaleLogo,
        desc: [`• Led the development as part of a team of 4 backend developers using Node.js; managed client interactions and
presentations, ensuring requirements were met.`,`• Developed APIs that reduced paper usage by 99%, created an online helpdesk, integrated QR code-based attendance scanning, and enabled online submission of suggestions for resolutions.`]
    },
    {
        date: "April 2023 - June 2023",
        logo: Dot3Logo,
        title: "Frontend Intern",
        subtitle: "Tech Stack: React JS, JavaScript",
        desc: ["• Worked on Admin panel of Unlock fit using ReactJS.",`• Successfully integrated APIs using Axios, enabling seamless communication between the front-end and back-end
systems.`]
    }

];

const Experience = React.forwardRef(({ expRef }) => {
    return (
        <section className='p-5 outline outline-blue-400' ref={expRef}>
            <h2 className='px-5 font-semibold text-3xl text-blue-500 underline'>Experience</h2>
            <TimeLine data={data} />
        </section>
    );
});

export default Experience;